import { createActionGroup, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { IApiError } from '@app/core/interfaces/error';
import {
  ISystemParam,
  ISystemParamUpdateParams,
} from '@app/core/interfaces/system-params';

interface SystemParamsActionSource {
  source: string;
}

export const SystemParamsActions = createActionGroup({
  source: 'SYSTEM PARAMS ADMIN',
  events: {
    activateSource: props<SystemParamsActionSource>(),
    selectParam: props<
      SystemParamsActionSource & { id: string | 'new' | null }
    >(),
    attemptSelectParam: props<
      SystemParamsActionSource & { id: string | 'new' | null }
    >(),
    requestParamInfo: props<SystemParamsActionSource & { id: string }>(),
    requestParamInfoSuccess: props<
      SystemParamsActionSource & { param: ISystemParam }
    >(),
    requestParamInfoError: props<{
      source: string;
      error: HttpErrorResponse & { error: IApiError };
    }>(),
    requestUpdateParam: props<{
      source: string;
      id: string;
      params: ISystemParamUpdateParams;
    }>(),
    requestUpdateParamSuccess: props<
      SystemParamsActionSource & { id: string }
    >(),
    requestUpdateParamError: props<{
      source: string;
      error: HttpErrorResponse & { error: IApiError };
    }>(),
    setFormValues: props<
      SystemParamsActionSource & { form: Partial<ISystemParam> }
    >(),
    closeParam: props<SystemParamsActionSource>(),
    clearParam: props<SystemParamsActionSource>(),
  },
});
